import { NotImplementedYet } from '../../utils';
import { AbstractConnectionStrategy } from '../abstract-connection-strategy';
export class BroadcastChannelStrategy extends AbstractConnectionStrategy {
  constructor(...args) {
    super(...args);
    this.name = 'broadcast-channel-strategy';
    this.onTopicSubscriptionsChange = __onChange => {
      throw new NotImplementedYet();
    };
  }
  getHandshakeResult() {
    throw new NotImplementedYet();
  }
  open() {
    throw new NotImplementedYet();
  }
  close() {
    throw new NotImplementedYet();
  }
  getActiveTopicSubscriptions() {
    throw new NotImplementedYet();
  }
}